module.exports = __webpack_public_path__ + "static/img/down_logo.bb2b9010.png";